<script>
import DataViewListVue from '@/app/arch/components/dataView/DataViewList.vue';

export default {
  name: 'ConciliationSuggestion',
  extends: DataViewListVue,
  data: (vm) => ({
    content: [
      {
        text: 'Nome',
        value: 'clientName',
      },
      {
        text: 'Documento',
        value: 'clientDocument',
        handle: vm.formatDocument,
      },
      {
        text: 'Banco',
        value: 'bankName',
      },
      {
        text: 'Agência',
        value: 'agency',
      },
      {
        text: 'Conta',
        value: 'account',
      },
      {
        text: 'Valor',
        value: 'value',
      },
      {
        text: 'Situação',
        value: 'situation',
      },
      {
        text: 'Data da pendência',
        value: 'createdAt',
        handle: vm.handleDate,
      },
    ],
  }),
  methods: {
    handleSuggestionDate(key) {
      return this.handleDate(
        key,
        'DD/MM/YYYY - HH:MM:SS',
      );
    },
  },
};
</script>
